import Menu from './Menu'
import Videos from './Videos'
import Blogs from './Blogs'
import Profiles from './Profiles'

const Home = {
  Menu,
  Videos,
  Blogs,
  Profiles
}

export default Home
